const isInvalid = function (email) {
  if (email === '') {
    throw new Error('メールアドレスが空です。入力をお願いします。');
  }

  const email_validation = /^[^@]+@[^@]+$/;
  if (!email_validation.test(email)) {
    throw new Error('メールアドレスの形式が正しくありません。入力し直してください');
  }
  return false;
};

export default { isInvalid };
